import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Kiire tarne

  <span style="color:#85c1dc;">**FI:**</span>
  Nopea toimitus!

  <span style="color:#85c1dc;">**RU:**</span>
  Быстрая доставка!
*/
/* @__NO_SIDE_EFFECTS__ */
const m278 = msg(
  mf`Kiire tarne`,
  mf`Nopea toimitus!`,
  mf`Быстрая доставка!`,
)

export { m278 as 'w.module.product.label_shipping' }